"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isAthleteFemale(athlete) {
    return !athlete || !athlete.gender
        ? false
        : athlete.gender.toLowerCase() === 'female' ||
            athlete.gender.toLowerCase() === 'f';
}
exports.default = isAthleteFemale;
//# sourceMappingURL=isAthleteFemale.js.map


//////////////////
// WEBPACK FOOTER
// ../lib-score-systems/dist/imports/isAthleteFemale.js
// module id = 60
// module chunks = 0